import request from '@/utils/bbs_request'

// 获取机构名称
export function getAgencyInfo(params) {
  return request({
    url: '/index/index/getAgencyInfo',
    method: 'get',
    params
  })
}
// 获取App
export function getAgencyAppList(params) {
  return request({
    url: '/index/index/getAgencyAppList',
    method: 'get',
    params
  })
}
